/**
 * How many milliseconds are in a day
 * @type {Number}
 */
export const DAY_IN_MS = 864e5;
